import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PriceHistoryService {

  public mtds: Methods = new Methods();
  public url: string;
  public urlCountries: string;
  public token;
  public headers;

  constructor(private http: HttpClient) {
    this.url = GLOBAL.url + '/inventory/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  showAll(page = 1, perPage = 10, busqueda = '', item = '', mfgr = '', filter_show_inventory = 'All', filtros = []): Observable<any> {
    let json = null;
    if (busqueda === '' && item === '' && mfgr !== '') {
      json = {
        filtersecondvalue: mfgr,
        filter_show_inventory
      };
    } else if (busqueda === '' && item !== '' && mfgr === '') {
      json = {
        filtertype: 'pricehistory', filtervalue: item,
        filter_show_inventory
      };
    } else if (busqueda === '' && item !== '' && mfgr !== '') {
      json = {
        filtertype: 'pricehistory', filtervalue: item,
        filtersecondvalue: mfgr,
        filter_show_inventory
      };
    } else if (busqueda !== '' && item === '' && mfgr === '') {
      json = {
        busqueda,
        filter_show_inventory
      };
    } else if (busqueda !== '' && item === '' && mfgr !== '') {
      json = {
        busqueda,
        filtersecondvalue: mfgr,
        filter_show_inventory
      };
    } else if (busqueda !== '' && item !== '' && mfgr === '') {
      json = {
        busqueda,
        filtertype: 'pricehistory', filtervalue: item,
        filter_show_inventory
      };
    } else if (busqueda !== '' && item !== '' && mfgr !== '') {
      json = {
        busqueda,
        filtertype: 'pricehistory', filtervalue: item,
        filtersecondvalue: mfgr,
        filter_show_inventory
      };
    }

    let filtro_url = '';

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        filtro_url = filtro_url + '&' + filtro.key + '=' + filtro.value;
        if (filtro.type) {
          filtro_url = filtro_url + '&' + filtro.key_type + '=' + filtro.type;
        }
      }
    }

    return this.petition(
      `${this.url}listpricehistory?page=${page}&perpage=${perPage}${filtro_url}`,
      json
    );
  }

  showAllOpti(page = 1, perPage = 10, busqueda = '', item = '', mfgr = '', filter_show_inventory = 'All', filtros = [],    task:any,
  order:any): Observable<any> {
    let json = null;
    if (busqueda === '' && item === '' && mfgr !== '') {
      json = {
        filtersecondvalue: mfgr,
        filter_show_inventory
      };
    } else if (busqueda === '' && item !== '' && mfgr === '') {
      json = {
        filtertype: 'pricehistory', filtervalue: item,
        filter_show_inventory
      };
    } else if (busqueda === '' && item !== '' && mfgr !== '') {
      json = {
        filtertype: 'pricehistory', filtervalue: item,
        filtersecondvalue: mfgr,
        filter_show_inventory
      };
    } else if (busqueda !== '' && item === '' && mfgr === '') {
      json = {
        busqueda,
        filter_show_inventory
      };
    } else if (busqueda !== '' && item === '' && mfgr !== '') {
      json = {
        busqueda,
        filtersecondvalue: mfgr,
        filter_show_inventory
      };
    } else if (busqueda !== '' && item !== '' && mfgr === '') {
      json = {
        busqueda,
        filtertype: 'pricehistory', filtervalue: item,
        filter_show_inventory
      };
    } else if (busqueda !== '' && item !== '' && mfgr !== '') {
      json = {
        busqueda,
        filtertype: 'pricehistory', filtervalue: item,
        filtersecondvalue: mfgr,
        filter_show_inventory
      };
    }
    if (!json) {
      json = {};
    }
  
    json.sort = task; 
    json.order = order;
    let filtro_url = '';

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        filtro_url = filtro_url + '&' + filtro.key + '=' + filtro.value;
        if (filtro.type) {
          filtro_url = filtro_url + '&' + filtro.key_type + '=' + filtro.type;
        }
      }
    }

    return this.petition(
      `${this.url}listpricehistoryopti?page=${page}&perpage=${perPage}${filtro_url}`,
      json
    );
  }

  searchfilger(item): Observable<any> {
    return this.petition(
      `${GLOBAL.url}/masteritem/searchbypartnumber`,
      { busqueda: item }
    );
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let paramas, response;
    paramas = 'authorization=' + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      paramas = paramas + '&json=' + json;
    }

    if (type != null) {
      paramas = paramas + '&type=' + type;
    }

    response = this.http.post(url, paramas, { headers: this.headers });

    if (response.code === 404) {
      this.mtds.notifyError('Your session has expired');
      localStorage.clear();
      // You need to handle navigation using Angular Router
      // this._router.navigate(['/pages/lock']);
    }

    return response;
  }
}
